export const ANIO = 4;
export const OBSERVACIONES = 4000;
export const DUDAS = 4000;

const salida = { ANIO, OBSERVACIONES, DUDAS };

export default salida;